module.exports = __webpack_public_path__ + "static/media/MU_Landing_Page_TC_4x5.5175c4c9.vtt";